import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

// Attach admin token to requests if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 globally
api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      const path = window.location.pathname;
      if (path.startsWith('/admin') && path !== '/admin/login') {
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminUser');
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

// ── Public API ──────────────────────────────────────────
export const getFiles = () => api.get('/files');

export const verifyCredentials = (fileId, username, password) =>
  api.post('/files/verify', { fileId, username, password });

export const getDownloadUrl = (fileId, token) =>
  `${BASE_URL}/files/download/${fileId}?token=${token}`;

// ── Admin API ───────────────────────────────────────────
export const adminLogin = (username, password) =>
  api.post('/admin/login', { username, password });

export const adminGetFiles = () => api.get('/admin/files');

export const adminUploadFile = (formData) =>
  api.post('/admin/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const adminDeleteFile = (id) => api.delete(`/admin/files/${id}`);

export default api;
